import { ControlSheetDTO, TripDTO } from '@/types/controlsheet'
import { tripContainsMealRelief } from './spellTimeForTrip'
import { annotationMapper } from './annotationMapper'
import { getTimeDifferenceInMinutes } from './timeDiff'
import { ControlSheetAnnotation } from '../types/types'

const tripAffectedByLateMealRelief = (
    trip: TripDTO,
    tempAnnotations: ControlSheetAnnotation[],
    minMealRelief: number
): { trip: string; duty: string } | undefined => {
    if (trip && tripContainsMealRelief(trip)) {
        const annotations = [
            ...trip.annotations.map(annotationMapper()),
            ...tempAnnotations.filter((annotation) => annotation.tripNumber === trip.trip),
        ]

        const mealRelief = annotations.filter((annotation) => annotation.annotationType === 'MealRelief')
        if (mealRelief.length > 0) {
            const annotation = mealRelief[0]
            const startTime = annotation.startTime ?? trip.breakStartTime
            const endTime = annotation.departureTime ?? trip.breakEndTime
            if (startTime && endTime) {
                const diff = getTimeDifferenceInMinutes(startTime, endTime)
                if (diff && diff > minMealRelief) {
                    return {
                        trip: String(trip.nextTripForDuty),
                        duty: trip.duty,
                    }
                }
            }
        }
    }
    return undefined
}

export const tripsAndDutiesAffectedByLateMealRelief = (
    routeData: ControlSheetDTO | undefined,
    tempAnnotations: ControlSheetAnnotation[]
): { trip: string; duty: string }[] => {
    if (!routeData) {
        return []
    }
    const ret = routeData.runs.flatMap((run) => {
        return run.tripPairs.flatMap((tripPair) => {
            const outboundTrip = tripPair.outbound
            const inboundTrip = tripPair.inbound
            const tripsToReturn = []
            if (outboundTrip) {
                const tripAffected = tripAffectedByLateMealRelief(outboundTrip, tempAnnotations, 15)
                if (tripAffected) {
                    tripsToReturn.push(tripAffected)
                }
            }
            if (inboundTrip) {
                const tripAffected = tripAffectedByLateMealRelief(inboundTrip, tempAnnotations, 15)
                if (tripAffected) {
                    tripsToReturn.push(tripAffected)
                }
            }
            return tripsToReturn
        })
    })

    return ret
}
